import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/ClientShell.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/v3-shell.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/nav/nav-v2.css");
